import { closePanel, slideoutPanel, openPanel, updatePanel } from '../slideout-panel/slideout-panel';
import { fetchText } from '../fetch-helper/fetch-helper';
import { sendDeliveryInformationToServer } from '../delivery-accordion/delivery-accordion';
import { gtag } from '../utility-functions/utility-functions';

export const storeList = () => {
    const stores = document.querySelectorAll('.stores-list__item') as NodeListOf<HTMLElement>;
	const reset = document.querySelector('.js-reset-store-postcode') as HTMLElement;
	const storeId = document.getElementById('ddlStoreId') as HTMLInputElement;

	stores.forEach((store) => {
		store.querySelector('.js-store-read-more').addEventListener('click', () => {
			store.classList.toggle('active');

			const button = store.querySelector('.js-store-read-more') as HTMLElement;
			const buttonText = button.textContent;

			if (buttonText == "View more") {
				button.innerHTML = 'View less';
			} else {
				button.innerHTML = 'View more';
			}

		});

		store.querySelector('.js-select-click-and-collect-store').addEventListener('click', () => {
			storeId.value = store.dataset.id;
			closePanel('CC');
			sendDeliveryInformationToServer();
			if (store.dataset.name) gtag('event', 'click_and_collect_interaction', { store_selected: store.dataset.name });
		});
	});

    if (reset !== null) {
        reset.addEventListener('click', () => {
			fetchStoresSearch(null);
        });
    }
}

export const fetchStoresSearch = (postcode) => {
	const url = `/basket/getclickandcollectstores?postcode=${postcode ? postcode : ""}`;
	const CC = fetchText(url, null);

	CC.then(html => {
		updatePanel('CC', html);
		handleStoreSearchFormSubmit();
		storeList();
	});
}

export const handleStoreSearchFormSubmit = () => {
	const form = document.querySelector('.js-store-search');
	const submitBtn = form?.querySelector<HTMLButtonElement>('[type="submit"]');

	if (form !== null) {
		form.addEventListener('submit', (e) => {
			e.preventDefault();

			submitBtn.disabled = true;
			submitBtn.innerHTML = "Searching...";

			const formData = new FormData(e.target);
			let postcode = formData.get("postcode") as string;
			postcode = postcode.replace(/\s+/g, '');

			try {
				fetchStoresSearch(postcode);

				gtag('event', 'store_finder', {
					'search_term': postcode
				});

			} catch (e) {
				submitBtn.disabled = false;
				submitBtn.innerHTML = "Search";
			}
		});
	}
}